/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_LOGIN_OTP_LIST,
  UPDATE_LOGIN_OTP_LIST,
  DELETE_LOGIN_OTP_LIST,
} from "./constants"

import {
  loadLoginOtp,
  loadLoginOtpSuccess,
  loadLoginOtpError,
  updateLoginOtpSuccess,
  updateLoginOtpError,
  deleteLoginOtpSuccess,
  deleteLoginOtpError,
} from "./actions"

import {
  loadLoginOtpDetails,
  updateLoginOtpDetails,
  deleteLoginOtpDetails,
} from "./remotes"

// import { selectSession } from "../session/selectors"
// import { roleIds } from "../../helpers/tools"

function* loadLoginDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_LOGIN_OTP_LIST),
    })

    const { explicitLoad } = load

    yield put(loadLoginOtp(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadLoginOtpDetails)

        if (result) {
          yield put(loadLoginOtpSuccess(result.data))
        } else {
          yield put(loadLoginOtpError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadLoginOtpError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* updateLoginDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_LOGIN_OTP_LIST),
    })

    const { updateLoginOtp } = edit || {}
    if (edit) {
      try {
        yield call(updateLoginOtpDetails, updateLoginOtp)

        yield put(
          updateLoginOtpSuccess(updateLoginOtp, "Record Updated Successfully")
        )
      } catch (error) {
        yield put(
          updateLoginOtpError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* deleteLoginDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { del } = yield race({
      del: take(DELETE_LOGIN_OTP_LIST),
    })
    const { deleteLoginOtp } = del || {}
    if (del) {
      try {
        yield call(deleteLoginOtpDetails, deleteLoginOtp)
        console.log(deleteLoginOtp, "saga for delete event")

        yield put(
          deleteLoginOtpSuccess(
            deleteLoginOtp,

            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          deleteLoginOtpError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}


export default function* recordsSaga() {
  yield all([
    loadLoginDetailsSaga(),
    updateLoginDetailsSaga(),
    deleteLoginDetailsSaga(),
  ])
}
